import { render, staticRenderFns } from "./CogneetivPredict.vue?vue&type=template&id=b43eba8c&scoped=true&"
import script from "./CogneetivPredict.vue?vue&type=script&lang=js&"
export * from "./CogneetivPredict.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivPredict.vue?vue&type=style&index=0&id=b43eba8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43eba8c",
  null
  
)

export default component.exports